import { Extension, Plugin } from 'tiptap'
import http from '../../../utils/http'

async function uploadFiles(url = '', token = '', files = []) {
  const multiple = files.length > 1
  const formData = new FormData()

  if (multiple) {
    files.forEach((image, index) => {
      formData.append(`files[${index}]`, image)
    })
  } else {
    formData.append('file', files[0])
  }

  return http.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token,
    },
  })
}

export default class Dropper extends Extension {
  constructor(options) {
    super(options)
  }

  get name() {
    return 'dropper'
  }

  get defaultOptions() {
    return {
      token: null,
      fileUploadUrl: null,
      imageUploadUrl: null,
    }
  }

  commands() {
    return (attrs) => () => {
      this.dropCommand(attrs)
      return true
    }
  }

  async dropCommand(fileList, position) {
    const {view} = this.editor
    const {token, fileUploadUrl, imageUploadUrl} = this.options
    // separate images from regular files
    const images = []
    const files = []

    Array.from(fileList).forEach((file) => {
      if (/image/i.test(file.type)) {
        images.push(file)
      } else {
        files.push(file)
      }
    })

    if (images.length === 0 && files.length === 0) {
      return
    }

    const {schema} = view.state
    const coordinates = position
      ? view.posAtCoords({
          left: position.x,
          top: position.y,
        })
      : null

    const addItemToView = ({type, ...props}) => {
      // type = 'image' | 'file'
      const node = schema.nodes[type].create({...props})
      const lastCursorPosition = +localStorage.getItem('htmleditor.lastCursorPosition')
      const pos = coordinates ? coordinates.pos : lastCursorPosition
      const transaction = view.state.tr.insert(pos, node)
      view.dispatch(transaction)
    }

    // Upload files
    if (files.length > 0 && fileUploadUrl) {
      uploadFiles(fileUploadUrl, token, files)
        .then((response) => {
          const url = response.data.link
          addItemToView({type: 'file', src: url, text: response.data.path})
        })
        .catch(() => {})
    }

    // Upload images
    if (images.length > 0 && imageUploadUrl) {
      uploadFiles(imageUploadUrl, token, images)
        .then((response) => {
          const url = response.data.link
          addItemToView({type: 'image', src: url})
          // if (multiple) {
          //   return
          // } else {
          //   const url = response.data.link
          //   addItemToView({src: url})
          // }
        })
        .catch()
        .finally()
    } else {
      // reading images as base64
      images.forEach((image) => {
        const reader = new FileReader()
        reader.onload = (readerEvent) =>
          addItemToView({
            type: 'image',
            src: readerEvent.target.result,
          })
        reader.readAsDataURL(image)
      })
    }
  }

  get plugins() {
    const dropCommand = this.dropCommand.bind(this)

    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            // TODO: extract a common function from these two events
            drop(view, event) {
              const hasFiles =
                event.dataTransfer &&
                event.dataTransfer.files &&
                event.dataTransfer.files.length

              if (!hasFiles) {
                return
              }

              event.preventDefault()

              const position = {x: event.clientX, y: event.clientY}
              dropCommand(event.dataTransfer.files, position)
            },

            // mainly for handling pasting images from word
            paste(view, event) {
              const hasFiles =
                event.clipboardData &&
                event.clipboardData.files &&
                event.clipboardData.files.length

              if (!hasFiles) {
                return
              }

              event.preventDefault()

              const {from} = view.state.selection
              const {left, top} = view.coordsAtPos(from)
              dropCommand(event.clipboardData.files, {x: left, y: top})
            },
          },
        },
      }),
    ]
  }
}
